"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgShapeRenderer = ({ id = "shape", type = "rect", x = 0, y = 0, width = 120, height = 120, fill = "lightblue", stroke = "black", strokeWidth = 2, text = "", textFill = "black", radius = 50, sides = 3, numPoints = 5, innerRadius = 20, outerRadius = 40, points = [], radiusX = 60, radiusY = 40, cornerRadius = 12, rotation = 0, isSelected = false, onSelect, onStartEdit, }) => {
    const centerX = width / 2;
    const centerY = height / 2;
    const transform = `translate(${centerX}, ${centerY}) rotate(${rotation}) translate(${-centerX}, ${-centerY})`;
    const renderShape = () => {
        switch (type) {
            case "circle":
                return ((0, jsx_runtime_1.jsx)("circle", { cx: centerX, cy: centerY, r: radius, fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
            case "triangle":
                const trianglePoints = [
                    `${centerX},${height * 0.1}`,
                    `${width * 0.1},${height * 0.9}`,
                    `${width * 0.9},${height * 0.9}`
                ].join(" ");
                return ((0, jsx_runtime_1.jsx)("polygon", { points: trianglePoints, fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
            case "diamond":
                const diamondPoints = [
                    `${centerX},${height * 0.1}`,
                    `${width * 0.9},${centerY}`,
                    `${centerX},${height * 0.9}`,
                    `${width * 0.1},${centerY}`
                ].join(" ");
                return ((0, jsx_runtime_1.jsx)("polygon", { points: diamondPoints, fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
            case "oval":
                return ((0, jsx_runtime_1.jsx)("ellipse", { cx: centerX, cy: centerY, rx: radiusX, ry: radiusY, fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
            case "rounded-rect":
                return ((0, jsx_runtime_1.jsx)("rect", { x: 0, y: 0, width: width, height: height, rx: cornerRadius, ry: cornerRadius, fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
            case "star-5":
                const starPoints = [];
                for (let i = 0; i < numPoints * 2; i++) {
                    const angle = (i * Math.PI) / numPoints;
                    const r = i % 2 === 0 ? outerRadius : innerRadius;
                    const px = centerX + r * Math.cos(angle - Math.PI / 2);
                    const py = centerY + r * Math.sin(angle - Math.PI / 2);
                    starPoints.push(`${px},${py}`);
                }
                return ((0, jsx_runtime_1.jsx)("polygon", { points: starPoints.join(" "), fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
            case "pentagon":
                if (points.length >= 6) {
                    const polygonPoints = [];
                    for (let i = 0; i < points.length; i += 2) {
                        polygonPoints.push(`${points[i]},${points[i + 1]}`);
                    }
                    return ((0, jsx_runtime_1.jsx)("polygon", { points: polygonPoints.join(" "), fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
                }
                // Fallback to triangle if not enough points
                const fallbackPoints = [
                    `${centerX},${height * 0.1}`,
                    `${width * 0.1},${height * 0.9}`,
                    `${width * 0.9},${height * 0.9}`
                ].join(" ");
                return ((0, jsx_runtime_1.jsx)("polygon", { points: fallbackPoints, fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
            default: // rect
                return ((0, jsx_runtime_1.jsx)("rect", { x: 0, y: 0, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth }));
        }
    };
    return ((0, jsx_runtime_1.jsx)("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, style: {
            cursor: "pointer",
            userSelect: "none",
            outline: isSelected ? "2px solid #0078ff" : "none",
            outlineOffset: "2px",
            width: "100%",
            height: "100%",
            display: "block",
        }, onClick: onSelect, onDoubleClick: onStartEdit, children: (0, jsx_runtime_1.jsxs)("g", { transform: transform, children: [renderShape(), text && ((0, jsx_runtime_1.jsx)("text", { x: width / 2, y: height / 2, textAnchor: "middle", dominantBaseline: "middle", fill: textFill, fontSize: "14", style: {
                        pointerEvents: "none",
                        wordBreak: "break-word",
                        maxWidth: width - 16,
                        overflow: "hidden",
                    }, children: text }))] }) }));
};
exports.default = SvgShapeRenderer;
